module.exports = __webpack_public_path__ + "img/info-icon.51f05560.svg";